import script from "./MarvinChat.vue?vue&type=script&setup=true&lang=js"
export * from "./MarvinChat.vue?vue&type=script&setup=true&lang=js"

import "./MarvinChat.vue?vue&type=style&index=0&id=7b1685f2&lang=scss"

const __exports__ = script;

export default __exports__